import { Icon } from "components/Icon";
import { useEffect, useState } from "react";

type Props = {
  circle?: boolean;
  size?: string;
  url?: string;
  rounded?: string;
  className?: string;
};

export function Avatar({ 
  circle = false, 
  size = 'w-full', 
  url, 
  rounded,
  className = '',
}: Props) {
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setImageError(false);
  }, [url]);

  const handleError = (_event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    setImageError(true);
  };

  if (!url || imageError) {
    return (
      <div className={`flex items-center justify-center ${size} ${rounded || 'rounded-xl'} ${className}`}>
        <Icon icon="userProfile" width={56} height={56} />
      </div>
    );
  }

  return (
    <img
      className={`inline-block aspect-square object-cover object-top ${size} ${
        circle ? 'rounded-full' : rounded || ''
      } ${className}`}
      src={url}
      alt="User avatar"
      onError={handleError}
    />
  );
}